import PingSocket, { PingSocketType } from '../base/socket/Ping.socket';
import { SocketEvent } from '../base/socket/event';
import Emitter from './Emitter.module';
import { AppEvent } from '../background-components/EventHandler';
import { CALL_SOCKET_URL } from '../constants';
import { PingGroup } from '../types/pingGroup';

export class SocketModule {
  private static socket: PingSocket | null;

  public static init = async (userId: string, accessToken: string): Promise<void> => {
    SocketModule.cleanUp();
    SocketModule.socket = new PingSocket(PingSocketType.Call, CALL_SOCKET_URL);
    SocketModule.socket.setUserId(userId);
    SocketModule.socket.setAccessToken(accessToken);
    SocketModule.socket?.on(SocketEvent.UserInvalidSession, SocketModule.onUserInvalidSession);
    SocketModule.socket?.on(SocketEvent.PingGroupUpdated, SocketModule.onPingGroupUpdated);
  };

  public static cleanUp = (): void => {
    SocketModule.socket?.off(SocketEvent.UserInvalidSession, SocketModule.onUserInvalidSession);
    SocketModule.socket?.off(SocketEvent.PingGroupUpdated, SocketModule.onPingGroupUpdated);
    SocketModule.socket = null;
  };

  static onUserInvalidSession = (data: any) => {
    console.log('onUserInvalidSession', data);
    Emitter.emit(AppEvent.onUserInvalidSession, data);
  };

  static onPingGroupUpdated = (data: { pingGroup: PingGroup }) => {
    console.log('onPingGroupUpdated', data);
    Emitter.emit(AppEvent.onPingGroupUpdated, data.pingGroup);
  };

  static on(event: string, listener: (...args: any[]) => void): void {
    SocketModule.socket?.on(event, listener);
  }

  static off(event: string, listener?: (...args: any[]) => void): void {
    SocketModule.socket?.off(event, listener);
  }

  static emit = async <T>(event: string, data?: any) => {
    if (!SocketModule.socket) {
      throw new Error('Socket not initialized');
    }
    return await SocketModule.socket?.emit<T>(event, data);
  }
}
